import Api from '@/api/api';
import { getUrl as buildUrl } from '@/api/utils';
import type { HttpRequestConfig } from '@/api/http-provider';

export function createResourceApi(...resource: Array<number | string>) {
    const instance = new Api();

    function buildParts(parts: string | Array<number | string>) {
        return Array.isArray(parts) ? parts.filter(Boolean).join('/') : parts;
    }

    let base = buildParts(resource);
    base = base.startsWith('/') ? base : `/${base}`;

    function url(
        id?: string | number,
        action?: string | Array<number | string>,
        queryParams?: Record<string, unknown>,
    ) {
        const resourceUrl = id ? `${base}/${id}` : base;

        const finalUrl = action ? `${resourceUrl}/${buildParts(action)}` : resourceUrl;

        return queryParams ? buildUrl(finalUrl, queryParams) : finalUrl;
    }

    return {
        instance,

        base,

        get<T>(
            id?: string | number,
            action?: string | Array<number | string>,
            config?: HttpRequestConfig,
        ) {
            return instance.get<T>(url(id, action), config);
        },

        post<T>(
            id?: string | number,
            action?: string | Array<number | string>,
            data?: unknown,
            config?: HttpRequestConfig,
        ) {
            return instance.post<T>(url(id, action), data, config);
        },

        put<T>(
            id?: string | number,
            action?: string | Array<number | string>,
            data?: unknown,
            config?: HttpRequestConfig,
        ) {
            return instance.put<T>(url(id, action), data, config);
        },

        delete<T>(
            id?: string | number,
            action?: string | Array<number | string>,
            config?: HttpRequestConfig,
        ) {
            return instance.delete<T>(url(id, action), config);
        },
    };
}
